import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { EmailWelcomePage } from './email-welcome.page';

let routes = RouterModule.forChild([
    {path: "", component: EmailWelcomePage},
]);

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        routes,
    ],
    declarations: [
        EmailWelcomePage,
    ],
    exports: [
        EmailWelcomePage,
    ],
    providers: []
})
export class EmailWelcomeModule {}
